import constant from '../constant/constant'
import storage from  '../storage'

// 全局函数
var cusfunc = {
    // 判断对象是否为空
    isEmpty(obj) {
        if(typeof obj == "undefined" || obj == null || obj == ""){
            return true;
        }else{
            return false;
        }
    },
    // 判断是否为管理员
    isManagerUser() {
        var infoStr = storage.get(constant.LOGIN_INFO_KEY);
        if(this.isEmpty(infoStr)) {
            return false
        }
        var loginInfo = JSON.parse(infoStr);
        let userInfo = loginInfo.userInfo;
        let userStoreId = userInfo.storeId;
        if(userStoreId==constant.MANAGER_STORE_ID) {
            return true;
        } else {
            return false;
        }

    },
    // 判断是否有权限
    havePermission(permissionCode) {
        if(this.isEmpty(permissionCode)) {
            return true
        }
        // 从本地存储获取用户角色和权限
        var infoStr = storage.get(constant.LOGIN_INFO_KEY);
        if(this.isEmpty(infoStr)) {
            return false
        }
        var loginInfo = JSON.parse(infoStr);
        var roleId = loginInfo.roleId;
        if(roleId==constant.MANAGER_ROLEID) {
            return true
        }
        var permission = loginInfo.permission;
        if(permission.indexOf(permissionCode)>=0) {
            return true
        }
        return false
    }

}

export default cusfunc


// WEBPACK FOOTER //
// ./src/common/cusfunc/cusfunc.js